import { invokeApi } from "../../bl_libs/invokeApi";

/**
 * XAir staff console — /api/platform.
 *
 * Deliberately NOT the school portal's DAL. Those calls carry an
 * x-impersonate-school header and hit the school's own endpoints, which is the
 * shape that only ever shows what a school admin can see. These are staff
 * endpoints: cross-organisation, read-only, and attributed to the staff member
 * rather than to the school being looked at.
 */

const authHeaders = () => ({ "x-sh-auth": localStorage.getItem("token") });

export const platform_search_api = async (q) =>
  invokeApi({ path: `api/platform/search?q=${encodeURIComponent(q)}`, method: "GET", headers: authHeaders(), ignoreImpersonation: true });

export const platform_person_api = async (id) =>
  invokeApi({ path: `api/platform/person/${id}`, method: "GET", headers: authHeaders(), ignoreImpersonation: true });

export const platform_school_api = async (id) =>
  invokeApi({ path: `api/platform/school/${id}`, method: "GET", headers: authHeaders(), ignoreImpersonation: true });
